import * as React from "react";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { showYesNoPrompt, hideModal, showModal } from "../../../../redux/reducers/ModalReducer";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { SAVE_CHANGES_STATE_KEY, ADD_NEW_ACCOUNT_STATE_KEY, DELETE_ACCOUNT_STATE_KEY, UNDO_CHANGES_ACCOUNT_KEY, IP_MAINTENANCE_TOOLBAR, UNDO_METHOD_TOOLBAR, SAVE_METHOD_TOOLBAR, ADD_METHOD_TOOLBAR, DELETE_METHOD_TOOLBAR, HISTORY_METHOD_TOOLBAR, VERSION_HISTORY_STATE_KEY, ARTIST_MAINTENANCE_TOOLBAR, UNDO_CHANGES_ARTIST_KEY, ADD_NEW_ARTIST_STATE_KEY, DELETE_ARTIST_STATE_KEY, UNDO_ADJUSTMENT_CHANGES_STATE_KEY, COPY_ADJUSTMENT_STATE_KEY, DELETE_ADJUSTMENT_STATE_KEY, ADJUSTMENT_MAINTENANCE_TOOLBAR, COPY_METHOD_TOOLBAR, DELETE_ADJUSTMENTS_ROLE, ALL_ROLES, UPDATE_ADJUSTMENTS_ROLE, ADJUSTMENT_MODAL_HEADER, DELETE_ADJUSTMENT_PROMPT_STATE_KEY } from "../../../Consts";
import { UNDO_ICON, VERSION_HISTORY_ICON, COPY_ICON, DELETE_ICON } from "../../../Consts";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import ToolbarComponent from "../../../components/toolBar/ToolBarComponent";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { clearModalSearchResults, copyAdjustment, nextWorkflowInSession } from "../../../../redux/reducers/RepertoireReducer";
import { IAdjustmentState } from "../../../../redux/types/IAdjustmentState";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { DataSource } from "../../../types/DataSource";
import { IWorkflowParams } from "../../../types/IWorkFlowParams";
import { IWorkflowSearchResult } from "../../../types/IWorkflowSearchResult";
import { IYesNoPromptViewModalProps } from "../../../components/modalViews/yesNoPromptView/YesNoPromptView";
import { IDistribution } from "../../../types/usageTypes/IDistribution";

export interface IAdjustmentMaintenanceToolbarProps {
    changesMade: boolean;
    showYesNoPrompt: typeof showYesNoPrompt;
    hideModal: typeof hideModal;
    resetMessageBanner: () => void;
    scroll: number;
    toolbarWidth: number;
    toolbarData: IRepertoireComponentDataItem;
    saveResultData?: IRepertoireComponentDataItem;
    adjustment: IAdjustmentState;
    activeTab: number;
    tabs: ITabReduxItem[];
    lookupValues: ILookupDictionary;
    saveChanges: (saveOption?: string) => void;
    addNewAdjustment: (lookupValues: ILookupDictionary, isNew?: boolean, adjustmentMaintenanceGeneralViewData?: IRepertoireComponentDataItem) => void;
    undoAdjustmentChanges: () => void;
    searchVersionHistory: (adjustmentId: string, lookups: ILookupDictionary, actionList: IDataActionToolbar[], formats: FormatFields[]) => void;
    clearModalSearchResults?: typeof clearModalSearchResults;
    copyAdjustment: () => void;
    deleteAdjustment: (adjustmentID: string, activeTab: number) => void;
    distributions: IDistribution[];
    isReadonly: boolean;
    showModal: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void;
    roles?: string[];
    dataSource: string;
    workflowFieldsData: IRepertoireComponentDataItem;
    isWorkflowSessionStarted?: boolean;
    cancelWorkflowSession?: (activeTab: number) => void;
    nextWorkflowItem?: typeof nextWorkflowInSession;
    saveWorkflow?: (workflowparams: IWorkflowParams) => void;
    isOpenForWorkflowSession?: boolean;
    skipWorkflowItem?: (
        activeTab: number
        , currentWorkflowIndex: number
        , workflows: IWorkflowSearchResult[]
        , lookups: ILookupDictionary
        , otherIndicatorsWorkFlagTypes: string[]
        , dataActions: IDataActionToolbar[]
        , workMaintenanceGeneralDataViewData: IRepertoireComponentDataItem
        , formats: FormatFields[]
        , readonlyIndicatorsWorkFlagTypes: string[]) => void;
    workflowSessionItems?: IWorkflowSearchResult[];
    currentWorkflowIndex?: number;
    dataActionList?: IDataActionToolbar[];
    completeWorkflowOnSave: (value: boolean) => void;
}

export type IAdjustmentMaintenanceToolbarKeys = keyof IAdjustmentMaintenanceToolbarProps;

export interface IAdjustmentMaintenanceToolbarState {
    dataAction: IDataActionToolbar[];
}

class AdjustmentMaintenanceToolbar extends React.Component<
    IAdjustmentMaintenanceToolbarProps,
    IAdjustmentMaintenanceToolbarState
> {

    constructor(props) {
        super(props)
        this.state = {
            dataAction: this.getDataAction()
        };
    }
    componentDidUpdate(prevProps: IAdjustmentMaintenanceToolbarProps) {
        if (prevProps.adjustment !== this.props.adjustment) {
            this.setState({ dataAction: this.getDataAction() });
        }
    }

    saveChangesAction = (saveOption?: string) => {
        const { saveChanges } = this.props;
        saveChanges(saveOption);
    }

    searchVersionHistory = () => {
        const { searchVersionHistory, clearModalSearchResults, adjustment, lookupValues, tabs, activeTab } = this.props;
        const actionList = tabs[activeTab].dataActionToolbar;
        clearModalSearchResults();
        searchVersionHistory(adjustment.id, lookupValues, actionList, tabs[activeTab].formatFields);
    };

    copyAdjustment = () => {
        const { copyAdjustment } = this.props;
        copyAdjustment();
    }


    deleteAdjustment = () => {
        const { deleteAdjustment, hideModal, adjustment, activeTab } = this.props;
        deleteAdjustment(adjustment.id, activeTab);
        hideModal();
    }

    deleteAction = () => {
        const { toolbarData, showYesNoPrompt: showYesNoPromptProp, hideModal: hideModalProp } = this.props;
        
        const message: string = toolbarData.fields.find(f => f.name === DELETE_ADJUSTMENT_PROMPT_STATE_KEY).data;
        
        const propsModal: IYesNoPromptViewModalProps = {
            yesCallback: () => { this.deleteAdjustment(); }, 
            noCallback: () => { hideModalProp(); }
        }
        
        showYesNoPromptProp(ADJUSTMENT_MODAL_HEADER, propsModal, undefined, message);
    }

    getUpdateRoleDisabled = (): boolean => {
        const { roles } = this.props;
        if (roles && (roles.includes(UPDATE_ADJUSTMENTS_ROLE) || roles.includes(ALL_ROLES))) {
            return false;
        }
        return true;
    }

    getDeleteRoleDisabled = (): boolean => {
        const { roles, adjustment, distributions } = this.props;
        
        if (!roles || (!roles.includes(DELETE_ADJUSTMENTS_ROLE) && !roles.includes(ALL_ROLES))) {
            return true;
        }
        
        if (adjustment.dataSource === 'Posted') {

            const distribution = distributions?.find(d => d.distributionCode === adjustment.adjustmentDistribution);
            
            if (distribution) {
                
                const pool = distribution.distributionPools?.find(
                    p => p.poolCode === adjustment.adjustmentPool && p.segment === adjustment.adjustmentSegment
                );
                
                if (pool) {
                    if (pool.status === 'Allocated') {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    getDataAction() {
        const {
            undoAdjustmentChanges,
            toolbarData: { fields }
        } = this.props;

        const actionList: IDataActionToolbar[] = [];

        const undo: IDataActionToolbar = {
            action: undoAdjustmentChanges,
            component: ADJUSTMENT_MAINTENANCE_TOOLBAR,
            method: UNDO_METHOD_TOOLBAR,
            name: fields.find(undo => undo.name === UNDO_ADJUSTMENT_CHANGES_STATE_KEY).data,
            icon: UNDO_ICON,
            isReadOnly: this.getUpdateRoleDisabled()
        };
        actionList.push(undo);

        const searchVersionHistory: IDataActionToolbar = {
            action: this.searchVersionHistory,
            name: fields.find(save => save.name === VERSION_HISTORY_STATE_KEY).data,
            component: ADJUSTMENT_MAINTENANCE_TOOLBAR,
            method: HISTORY_METHOD_TOOLBAR,
            icon: VERSION_HISTORY_ICON
        };
        actionList.push(searchVersionHistory);

        const copyAdjustmentAction: IDataActionToolbar = {
            action: this.copyAdjustment,
            component: ADJUSTMENT_MAINTENANCE_TOOLBAR,
            method: COPY_METHOD_TOOLBAR,
            name: fields.find(d => d.name === COPY_ADJUSTMENT_STATE_KEY).data,
            icon: COPY_ICON,
            isReadOnly: this.getUpdateRoleDisabled()
        };
        actionList.push(copyAdjustmentAction)

        const deleteUsage: IDataActionToolbar = {
            action: this.deleteAction,
            component: ADJUSTMENT_MAINTENANCE_TOOLBAR,
            method: DELETE_METHOD_TOOLBAR,
            name: fields.find(f => f.name === DELETE_ADJUSTMENT_STATE_KEY)?.data,
            icon: DELETE_ICON,
            isReadOnly: this.getDeleteRoleDisabled()
        };
        actionList.push(deleteUsage);

        const save: IDataActionToolbar = {
            action: this.saveChangesAction,
            component: ADJUSTMENT_MAINTENANCE_TOOLBAR,
            method: SAVE_METHOD_TOOLBAR,
            name: fields.find(save => save.name === SAVE_CHANGES_STATE_KEY).data,
            icon: '',
            isReadOnly: this.getUpdateRoleDisabled()
        };
        actionList.push(save);

        return actionList;
    }

    render() {
        const {
            showYesNoPrompt,
            hideModal,
            resetMessageBanner,
            scroll,
            toolbarWidth,
            saveResultData,
            adjustment,
            activeTab,
            toolbarData,
            tabs,
            isReadonly,
            lookupValues,
            clearModalSearchResults,
            dataSource,
            workflowFieldsData,
            isWorkflowSessionStarted,
            cancelWorkflowSession,
            nextWorkflowItem,
            saveWorkflow,
            isOpenForWorkflowSession,
            skipWorkflowItem,
            workflowSessionItems,
            currentWorkflowIndex,
            dataActionList,
            completeWorkflowOnSave,
            roles
        } = this.props;

        let {
            changesMade,
        } = this.props;

        changesMade = !this.getUpdateRoleDisabled() && changesMade

        return (
            <div className={isReadonly ? 'versionHistoryPointer' : ''}>
                <ToolbarComponent
                    changesMade={adjustment.dataSource === 'Posted' ? false : changesMade}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    resetMessageBanner={resetMessageBanner}
                    scroll={scroll}
                    toolbarWidth={toolbarWidth}
                    saveResultData={saveResultData}
                    adjustment={adjustment}
                    activeTab={activeTab}
                    tabs={tabs}
                    dataActionToolbar={this.state.dataAction}
                    toolbarData={toolbarData}
                    component={ADJUSTMENT_MAINTENANCE_TOOLBAR}
                    isNew={tabs[activeTab].adjustmentMaintenanceState.isNew}
                    isReadonly={isReadonly}
                    lookupValues={lookupValues}
                    clearModalSearchResults={clearModalSearchResults}
                    dataSource={dataSource}
                    workflowFieldsData={workflowFieldsData}
                    isWorkflowSessionStarted={isWorkflowSessionStarted}
                    cancelWorkflowSession={cancelWorkflowSession}
                    nextWorkflowItem={nextWorkflowItem}
                    saveWorkflow={saveWorkflow}
                    isOpenForWorkflowSession={isOpenForWorkflowSession}
                    skipWorkflowItem={skipWorkflowItem}
                    workflowSessionItems={workflowSessionItems}
                    currentWorkflowIndex={currentWorkflowIndex}
                    dataActionList={dataActionList}
                    completeWorkflowOnSave={completeWorkflowOnSave}
                    roles={roles}
                />
            </div>
        );
    }

}

export default AdjustmentMaintenanceToolbar;
